import { Injectable } from '@angular/core';
import { GenericStateService } from '../../generic-state/generic-state.service';

@Injectable({
  providedIn: 'root'
})
export class SpaceTypeStoreService extends GenericStateService<any> { } {}
